/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable react/require-default-props */
/* eslint-disable prefer-arrow-callback */
import {
  memo, useEffect, useMemo, useRef,
} from 'react';
import {
  List, Container, Button, Typography, Stack,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import {
  add, differenceInDays, differenceInMonths, format, getDay, getMonth, startOfMonth,
} from 'date-fns';
import { Box, styled } from '@mui/system';
import { useDispatch } from 'react-redux';
import { removeReturnFlight } from '@/slices/selectedFlight/slices/selectedFlightSlice';
import CustomCalendar from '../CustomCalendar';
import type { TSetSelectedDate } from '../CustomCalendar/type';
import { setChooseReturn } from '../../slices/calendar/calendarSlice';
import { useAppSelector } from '../../utils/hook';
import type { TSelectedLocalDate } from '../../containers/SearchFlightTab';
import type { ICalendarListProps } from './type.d';
import { pr } from '@/utils/pxToRem';
import { style } from '@/styles/globals';
import { ILangObj } from '@/slices/goyoloSeo/sliceType';

const StyledContainer = styled(Container)({
  textAlign: 'center',
  backgroundColor: 'white',
  zIndex: 1,
  width: '100%',
  marginBottom: pr`16px`,
  marginTop: pr`16px`,
});
const StyledContainerSeo = styled(Container)({
  textAlign: 'center',
  backgroundColor: 'white',
  zIndex: 1,
  width: '100%',
  marginBottom: pr`16px`,
});
const StickyLowerControlContainer = styled(Box)({
  position: 'fixed',
  bottom: 0,
  zIndex: 3,
  background: 'white',
  display: 'flex',
  width: '100%',
  flexWrap: 'wrap',
  boxShadow:
    ' 0px 0px 0px 1px rgba(28, 59, 84, 0.05), 0px -2px 6px -2px rgba(28, 59, 84, 0.04), 0px -8px 12px -3px rgba(28, 59, 84, 0.08)',
});
const LowerDoneButton = styled(Button)({
  flexBasis: '100%',
  width: 0,
  margin: pr`16px`,
  marginTop: 0,
  height: 44,
  textAlign: 'center',
  color: 'white',
  fontWeight: 'bold',
});
const LowerInterlink = styled(Box)({
  width: '100%',
  position: 'absolute',
  textAlign: 'center',
  top: '7%',
  right: 0,
});
const StyledButton = styled(Button)({
  background: 'rgba(33, 33, 33, 0.08)',
  display: 'flex',
  height: 46,
  cursor: 'pointer',
  overflow: 'hidden',
  boxSizing: 'border-box',
  justifyContent: 'center',
  alignItems: 'center',
  transitionDelay: '0.1s',
  margin: `${style.spacing.inputToButton} 0 ${style.spacing.inputToButton} 0`,
  '&:hover': {
    background: '#EEF2F4',
  },
});

export const ButtonLabel = styled('p')`
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0;
  margin-bottom: 0;
  word-break: break-word;
  margin-top: 0px;
`;

const StickyLowerControl = ({
  selectedDate,
  onDone,
  chooseReturn,
  onChooseReturn,
  setSelectedDate,
  removeReturnFlight,
  selectDateClick,
  lang,
}: {
  selectedDate: TSelectedLocalDate;
  onDone: () => void;
  chooseReturn: boolean;
  onChooseReturn: (newStatus: boolean) => void;
  setSelectedDate: TSetSelectedDate;
  removeReturnFlight: () => void;
  selectDateClick?: any;
  lang?: ILangObj;
}) => {
  // const dispatch = useDispatch();
  const getDayText = (inputDate: Date) => {
    const day = getDay(inputDate);
    return `${day > 0 ? `T${day + 1}` : 'CN'} - ${format(
      inputDate,
      'dd/MM/yyyy',
    )}`;
  };
  let interLinkText = '';
  const departDate = selectedDate.depart;
  const returnDate = selectedDate.return ? selectedDate.return : null;
  if (departDate && returnDate) {
    const diffDates = differenceInDays(returnDate, departDate);
    if (diffDates === 0) {
      interLinkText = 'cùng ngày';
    } else {
      interLinkText = `${diffDates + 1} ngày`;
    }
  }

  return (
    <StickyLowerControlContainer>
      <Stack
        spacing="1.5em"
        sx={{
          p: '1.5em 1em',
          width: '100%',
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          width="100%"
          spacing={returnDate ? '50px' : pr`16px`}
        >
          <Button
            variant="outlined"
            color="secondary"
            fullWidth
            style={{
              // background: !chooseReturn ? '#C4C4C4' : '#F2F2F2',
              textAlign: 'left',
              padding: chooseReturn && returnDate ? '4px 16px' : '4px 8px',
              height: 50,
            }}
            onClick={() => selectDateClick({ isReturn: false })}
          >
            <Stack sx={{ width: '100%' }}>
              <Typography
                variant="caption"
                color={style.color.blue3}
              >
                <strong>Ngày đi</strong>
              </Typography>
              <Typography
                variant="body2"
                color={style.color.black1}
                lineHeight={1}
              >
                {getDayText(departDate)}
              </Typography>
            </Stack>
          </Button>
          <Button
            variant="outlined"
            fullWidth
            style={{
              background: !chooseReturn
                ? style.color.white2
                : chooseReturn && returnDate
                  ? 'white'
                  : style.color.black6,
              textAlign: 'left',
              border: '1px solid #B3B3B3',
              height: '100%',
              padding: chooseReturn && returnDate ? '4px 16px' : '4px 8px',
              minHeight: 50,
            }}
            onClick={() => selectDateClick({ isReturn: true })}
          >
            {returnDate ? (
              <>
                <Stack sx={{ width: '100%' }}>
                  <Typography
                    variant="caption"
                    color={style.color.blue3}
                    fontWeight="bold"
                  >
                    <strong>Ngày về</strong>
                  </Typography>
                  <Typography
                    variant="body2"
                    color={style.color.black1}
                    lineHeight={1}
                  >
                    {getDayText(returnDate)}
                  </Typography>
                </Stack>
                <CloseIcon
                  style={{
                    zIndex: 99,
                    position: 'absolute',
                    width: '18px',
                    height: '18px',
                    right: -8,
                    top: -8,
                    background: style.color.black3,
                    borderRadius: '50px',
                    color: '#ffffff',
                  }}
                  onClick={() => {
                    // dispatch(setReturnDate({ return: '' }));
                    setSelectedDate({ return: null });
                    removeReturnFlight();
                    onChooseReturn(false);
                  }}
                />
              </>
            ) : (
              <Stack
                direction="row"
                width="100%"
                spacing="0.2em"
                onClick={() => {
                  onChooseReturn(true);
                }}
                sx={{ alignItems: 'center' }}
              >
                <AddIcon
                  fontSize="small"
                  htmlColor={style.color.black1}
                />
                <Typography
                  style={{
                    width: '100%',
                    textAlign: 'left',
                  }}
                  variant="body2"
                  color={style.color.black1}
                >
                  Thêm ngày về
                  {/* <strong>Thêm ngày về</strong> */}
                  <Typography
                    style={{ display: 'inline' }}
                    variant="caption"
                    color={style.color.black4}
                  >
                    {' '}
                    (Không bắt buộc)
                  </Typography>
                </Typography>
              </Stack>
            )}
          </Button>
        </Stack>
        {interLinkText && (
          <LowerInterlink>
            <Typography
              variant="caption"
              component="span"
              color="#4F4F4F"
              style={{
                borderRadius: '10px',
                fontSize: '0.8rem',
                background: 'white',
                display: 'inline-block',
                height: 20,
                width: 64,
                borderLeft: `1px solid  ${style.color.blue3}`,
                borderRight: '1px solid  rgb(179, 179, 179)',
              }}
            >
              {interLinkText}
            </Typography>
          </LowerInterlink>
        )}
        <LowerDoneButton
          sx={{
            width: '100%',
            minHeight: '44px',
          }}
          color="primary"
          onClick={onDone}
          variant="contained"
        >
          Áp dụng
        </LowerDoneButton>
      </Stack>
    </StickyLowerControlContainer>
  );
};

const StickyLowerControlSeo = ({
  onDone, lang,
}: {
  onDone: () => void;
  lang?: ILangObj;
}) => (
  <StickyLowerControlContainer>
    <Stack
      spacing="1.5em"
      sx={{
        p: '1.5em 1em',
        width: '100%',
      }}
      direction="row"
    >
      <Button
        style={{
          width: '30%',
          background: '#fff',
          color: style.primary.navy,
          border: '1px solid #E0E0E0',
          borderRadius: '8px',
        }}
        className="search-btn"
        onClick={onDone}
      >
        <ButtonLabel
          style={{
            background: '#fff',
            color: `${style.primary.navy} !important`,
          }}
        >
          {lang?.global?.back || 'Quay lại'}
        </ButtonLabel>
      </Button>
      <Button
        style={{
          width: '60%',
        }}
        className="search-btn bg--vex-d-blue"
        onClick={onDone}
      >
        <ButtonLabel className="color--white">{lang?.SearchBar?.flightsTab?.continue || 'Tiếp tục'}</ButtonLabel>
      </Button>
    </Stack>
  </StickyLowerControlContainer>
);

const CompMemo = memo(
  function CustomCalendarMemo(props: any) {
    const {
      isNotShowPrice,
      highlightToday,
      monthAdded,
      dayPriceObj,
      selectedDate,
      setSelectedDate,
      month,
      year,
      seo,
      lang,
    } = props;
    const seoStyle = seo ? {
      textAlign: 'left',
      fontWeight: 700,
      fontSize: '18px',
      lineHeight: '24px',
      marginTop: '0px !important',
    } : {};
    return (
      <div>
        {seo
          ? (
            <StyledContainerSeo
              fixed
              sx={seoStyle}
            >
              <Typography
                variant="body2"
                color={seo ? style.neutral.black : style.color.black4}
                sx={seo ? {
                  textAlign: 'left',
                  fontWeight: 700,
                  fontSize: '18px',
                  lineHeight: '24px',
                } : {}}
                fontWeight="bold"
              >
                {lang?.lang === 'en' ? format(new Date(year, month, 1), 'MMMM yyyy') : `Tháng ${month + 1}, ${year}`}
              </Typography>
            </StyledContainerSeo>
          ) : (
            <StyledContainer
              fixed
              sx={seoStyle}
            >
              <Typography
                variant="body2"
                color={seo ? style.neutral.black : style.color.black4}
                sx={seo ? {
                  textAlign: 'left',
                  fontWeight: 700,
                  fontSize: '18px',
                  lineHeight: '24px',
                } : {}}
                fontWeight="bold"
              >
                {lang?.lang === 'en' ? format(new Date(year, month, 1), 'MMMM yyyy') : `'Tháng' ${month + 1}, ${year}`}
              </Typography>
            </StyledContainer>
          )}
        <CustomCalendar
          lang={lang}
          seo={seo}
          isNotShowPrice={isNotShowPrice}
          highlightToday={highlightToday}
          monthAdded={monthAdded}
          dayPriceObj={dayPriceObj}
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
        />
      </div>
    );
    // }, (prevProps, nextProps) => {
    //   const {
    //     departMonthDiff, returnMonthDiff, oldDepartMonthDiff, oldReturnMonthDiff, idx,
    //   } = nextProps;
    //   let check = true;

    //   if (oldReturnMonthDiff !== -1) {
    //     check = check && !(oldDepartMonthDiff <= idx && idx <= oldReturnMonthDiff);
    //   }
    //   if (oldDepartMonthDiff !== -1) {
    //     check = check && (oldDepartMonthDiff !== idx);
    //   }

    //   if (returnMonthDiff !== -1) {
    //     check = check && !(departMonthDiff <= idx && idx <= returnMonthDiff);
    //   }
    //   if (departMonthDiff !== -1) {
    //     check = check && (departMonthDiff !== idx);
    //   }

  //   return check;
  },
);

const CalendarList = ({
  setOpenDialog,
  dayPriceObj,
  selectedDate,
  setSelectedDate,
  isNotShowPrice,
  selectDateClick,
  seo,
  lang,
}: ICalendarListProps) => {
  const selectedDateRef = useRef(selectedDate);
  const monthStart = startOfMonth(new Date());
  const chooseReturn = useAppSelector((state) => state.calendar.chooseReturn);
  const dispatch = useDispatch();
  const setReturn = (newStatus: boolean) => dispatch(setChooseReturn({ chooseReturn: newStatus }));
  const handleRemoveReturnFlight = () => dispatch(removeReturnFlight());

  const diffMonthToNow = getMonth(new Date()) - getMonth(new Date());
  const limit = parseInt(
    process.env.NEXT_PUBLIC_CALENDAR_LIST_COUNT || '12',
    10,
  );
  const dataList = Array(limit).fill({});
  const CalendarComp = useMemo(
    () => (
      <List
        sx={{
          width: '100%',
          bgcolor: 'background.paper',
          position: 'relative',
          overflow: 'auto',
          maxHeight: seo ? 400 : 600,
          marginBottom: '150px',
          '& ul': { padding: 0 },
          seo: {},
        }}
        subheader={<li />}
      >
        {dataList.map((_, idx) => {
          const departMonthDiff = differenceInMonths(startOfMonth(selectedDate.depart), monthStart);
          const returnMonthDiff = selectedDate.return ? differenceInMonths(startOfMonth(selectedDate.return), monthStart) : -1;

          const oldSelectedDate = selectedDateRef.current;
          let oldDepartMonthDiff = -1;
          let oldReturnMonthDiff = -1;
          if (oldSelectedDate) {
            oldDepartMonthDiff = differenceInMonths(startOfMonth(oldSelectedDate.depart), monthStart);
            oldReturnMonthDiff = oldSelectedDate.return ? differenceInMonths(startOfMonth(oldSelectedDate.return), monthStart) : -1;
          }

          const nextMonth = add(new Date(), { months: idx + diffMonthToNow });
          const dateStr = format(nextMonth, 'yyyy/MM/dd');

          const ReturnComp = (
            <CompMemo
              lang={lang}
              seo={seo}
              key={dateStr}
              isNotShowPrice={isNotShowPrice}
              highlightToday={idx === 0}
              monthAdded={idx + diffMonthToNow}
              dayPriceObj={dayPriceObj}
              selectedDate={selectedDate}
              setSelectedDate={setSelectedDate}
              departMonthDiff={departMonthDiff}
              returnMonthDiff={returnMonthDiff}
              oldDepartMonthDiff={oldDepartMonthDiff}
              oldReturnMonthDiff={oldReturnMonthDiff}
              idx={idx}
              month={nextMonth.getMonth()}
              year={nextMonth.getFullYear()}
            />
          );
          if (idx === dataList.length - 1) {
            selectedDateRef.current = selectedDate;
          }

          return ReturnComp;
        })}
      </List>
    ),
    [chooseReturn, selectedDate],
  );

  const onSelectDateClickHandler = ({ isReturn = false }: { isReturn?: boolean }) => {
    if (selectDateClick) {
      selectDateClick(isReturn);
    }
  };

  return (
    <>
      {CalendarComp}
      {
      !seo && (
      <StickyLowerControl
        selectDateClick={onSelectDateClickHandler}
        removeReturnFlight={handleRemoveReturnFlight}
        selectedDate={selectedDate}
        setSelectedDate={setSelectedDate}
        chooseReturn={chooseReturn}
        onChooseReturn={setReturn}
        onDone={() => setOpenDialog(false)}
      />
      )
}
      {
      seo && (
      <StickyLowerControlSeo
        onDone={() => setOpenDialog(false)}
        lang={lang}
      />
      )
}
    </>
  );
};

export default CalendarList;
